import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

import { ConfirmationConfig, ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
	constructor(private dialog: MatDialog, private router: Router) {
		// automatically close the modal on route change
		this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
			this.dialog.closeAll();
		});
	}

	public confirm(config: ConfirmationConfig) {
		this.dialog.open<ConfirmationDialogComponent, ConfirmationConfig>(ConfirmationDialogComponent, {
			autoFocus: false,
			disableClose: true,
			width: '350px',
			data: config,
		});
	}
}
